import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
    async getListPromo({ commit }) {
        const data = [
            {
              "fitur": "masal_transaksi_cron",
              "kode": "aliqua qui exercitation",
              "expired": "2003-01-03T00:00:00.0Z",
              "diskon": 70,
              "max_diskon": 66027726
            },
            {
              "kode": "sit et tempor ea",
              "fitur": "masal_transaksi_cron",
              "expired": "1967-07-29T00:00:00.0Z",
              "max_diskon": 67224533,
              "diskon": 11
            },
            {
              "diskon": 1,
              "max_diskon": 2547673,
              "fitur": "masal_transaksi_cron",
              "expired": "1972-04-23T00:00:00.0Z",
              "kode": "velit enim"
            },
            {
              "diskon": 38,
              "fitur": "masal_transaksi",
              "max_diskon": 89619870,
              "expired": "1959-11-09T00:00:00.0Z",
              "kode": "exercitation culpa dolore quis eiusmod"
            },
            {
              "kode": "laborum labore",
              "fitur": "masal_transaksi_cron",
              "expired": "1963-04-25T00:00:00.0Z",
              "max_diskon": 45322876,
              "diskon": 1
            },
            {
              "diskon": 63,
              "kode": "voluptate dolore nostrud dolore",
              "max_diskon": 79017985,
              "expired": "2012-02-16T00:00:00.0Z",
              "fitur": "masal_transaksi_cron"
            },
            {
              "max_diskon": 44131055,
              "expired": "1966-02-07T00:00:00.0Z",
              "fitur": "masal_transaksi_cron",
              "kode": "irure nisi id dolore do",
              "diskon": 4
            },
            {
              "max_diskon": 53490361,
              "diskon": 32,
              "kode": "labore tempor eu",
              "fitur": "masal_transaksi_cron",
              "expired": "1982-03-01T00:00:00.0Z"
            },
            {
              "kode": "laboris minim",
              "expired": "1987-03-02T00:00:00.0Z",
              "fitur": "masal_transaksi_cron",
              "max_diskon": 94005516,
              "diskon": 67
            },
            {
              "diskon": 8,
              "kode": "commodo non ipsum velit dolor",
              "fitur": "masal_transaksi_cron",
              "max_diskon": 19235459,
              "expired": "1962-03-30T00:00:00.0Z"
            },
            {
              "fitur": "masal_transaksi_cron",
              "diskon": 2,
              "kode": "sint cupidatat dolor proident do",
              "max_diskon": 45348258,
              "expired": "1965-11-13T00:00:00.0Z"
            },
            {
              "diskon": 81,
              "kode": "voluptate veniam mollit ad",
              "expired": "1946-10-14T00:00:00.0Z",
              "fitur": "masal_transaksi_cron",
              "max_diskon": 50923640
            },
            {
              "fitur": "masal_transaksi_cron",
              "expired": "1945-12-01T00:00:00.0Z",
              "max_diskon": 83674368,
              "kode": "anim",
              "diskon": 35
            },
            {
              "expired": "1942-11-29T00:00:00.0Z",
              "fitur": "masal_transaksi",
              "diskon": 21,
              "kode": "in Duis culpa",
              "max_diskon": 58524411
            },
            {
              "kode": "consequat ea qui Ut anim",
              "fitur": "masal_transaksi",
              "diskon": 4,
              "expired": "2001-11-28T00:00:00.0Z",
              "max_diskon": 71431040
            },
            {
              "expired": "2014-11-13T00:00:00.0Z",
              "fitur": "masal_transaksi",
              "diskon": 54,
              "kode": "sed",
              "max_diskon": 27533144
            },
            {
              "fitur": "masal_transaksi_cron",
              "max_diskon": 63483701,
              "expired": "1986-06-10T00:00:00.0Z",
              "kode": "velit ut consectetur voluptate",
              "diskon": 20
            },
            {
              "kode": "tempor exercitation nostrud labore mollit",
              "diskon": 49,
              "expired": "1996-10-12T00:00:00.0Z",
              "max_diskon": 59847661,
              "fitur": "masal_transaksi"
            },
            {
              "diskon": 80,
              "max_diskon": 44525069,
              "fitur": "masal_transaksi",
              "expired": "2011-11-05T00:00:00.0Z",
              "kode": "eu et"
            },
            {
              "fitur": "masal_transaksi_cron",
              "expired": "2014-01-01T00:00:00.0Z",
              "diskon": 46,
              "max_diskon": 11240786,
              "kode": "aliqua ipsum"
            }
          ]
        return (data)
        try {
            const res = await conn.get(api.coupon.index);
            if (res.data.true) {
                commit('setPromoList', res.data.data);
                return resulter.successResult(res.data.data);
            }
        } catch (error) {
            return resulter.errorResult(error);
        }
    },
    validatingPromo: async ({ commit }, payload) => {
        setTimeout(() => {
            
        }, 1000);
        return {
          "coupon": {
            "diskon": 27,
            "expired": "1979-04-20",
            "fitur": "masal_transaksi",
            "idcoupon": 95505924,
            "is_global": 0,
            "kode": "non officia ullamco deserunt",
            "max_diskon": 34105300
          },
          "validation": true
        }
        try {
            const res = await conn.post(api.coupon.coupon_validaton, payload, conn.contentType.json)
            if (typeof res === 'string') {
                return resulter.errorResult(res)    
            }
            if (res.data.status) {
                return res.data.data
            }
            else {
                return resulter.errorResult(res.data.msg)    
            }
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
    claimPromo: async ({ commit }, payload) => {
        try {
            const res = await conn.post(api.coupon.cron_coupon_claim, payload, conn.contentType.json)
            if (typeof res === 'string') {
                return resulter.errorResult(res)    
            }
            if (res.data.status) {
                return resulter.successResult(res.data.msg) 
            }
            else {
                return resulter.errorResult(res.data.msg)    
            }
        } catch (error) {
            return resulter.errorResult(error)
        }
    },
    async getCoinEstimation({ commit }) {
        try {
            const res = await conn.get(api.coupon.cron_coupon_claim);
            if (res.data.true) {
                return resulter.successResult(res.data.data);
            }
            else {
                return resulter.errorResult(res.data.msg);
            }
        } catch (error) {
            return resulter.errorResult(error);
        }
    },
};
